var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Link \xE2\x86\x92 SVG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M46.8518 43.3717H9.29161C8.07075 43.3703 6.9003 42.8847 6.03706 42.0214C5.17382 41.158 4.68829 39.9875 4.68701 38.7667V15.5699C4.68829 14.349 5.17382 13.1785 6.03706 12.3152C6.9003 11.4519 8.07075 10.9662 9.29161 10.9648H46.8518C48.0726 10.9662 49.2431 11.4519 50.1063 12.3152C50.9696 13.1785 51.4551 14.349 51.4564 15.5699V38.7667C51.4551 39.9875 50.9696 41.158 50.1063 42.0214C49.2431 42.8847 48.0726 43.3703 46.8518 43.3717ZM9.29161 12.7248C8.53735 12.7257 7.81422 13.0257 7.28092 13.5591C6.74762 14.0924 6.44771 14.8156 6.44701 15.5699V38.7667C6.44771 39.5209 6.74762 40.2441 7.28092 40.7775C7.81422 41.3109 8.53735 41.6109 9.29161 41.6117H46.8518C47.606 41.6109 48.3292 41.3109 48.8625 40.7775C49.3958 40.2441 49.6957 39.5209 49.6964 38.7667V15.5699C49.6957 14.8156 49.3958 14.0924 48.8625 13.5591C48.3292 13.0257 47.606 12.7257 46.8518 12.7248H9.29161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.0718 32.3471C27.8573 32.3472 27.6501 32.2689 27.4892 32.1271L6.28125 13.4059L7.44593 12.0859L28.0718 30.2949L48.6986 12.0881L49.8633 13.4081L28.6552 32.1293C28.4939 32.2708 28.2864 32.3482 28.0718 32.3471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.80273 40.6074L20.05 24.3741L21.3736 25.5357L7.12625 41.769L5.80273 40.6074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M34.8149 25.5195L36.1385 24.3579L50.3861 40.5916L49.0625 41.7532L34.8149 25.5195Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailWhite);
export default __webpack_public_path__ + "static/media/Email_white.2ac7940ff0461f785a5e541b8c6f1617.svg";
export { ForwardRef as ReactComponent };